<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a *ngIf="this.loginPersonType == 'EMPLOYEE'">Material</a><a
            *ngIf="this.loginPersonType != 'EMPLOYEE'">Inventory Control</a></li>
          <li><a>Batch Transactions</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->
    <div class="block">
      <div class="screen_heading_div">
        <span>Batch Transactions</span>
      </div>
      <div class="nav_tabs_container">
        <ul>
          <li (click)="currentTab('feedlog')" class="active" data-toggle="tab" routerLink="/home/batchentrydashboard">
            <a>Feed Log</a></li>
          <li (click)="currentTab('treatment')" data-toggle="tab"><a>Treatment</a></li>
          <li (click)="currentTab('waterquality')" data-toggle="tab"><a>Water Quality</a></li>
          <li (click)="currentTab('currentmultilinepurchase')" data-toggle="tab"><a>Multiline
            Transaction</a></li>
        </ul>
      </div>
      <div class="row">
        <div class="buttons-div dashboard-add-view">
          <div class="transactions-button-container" *ngIf="!currentMultiLinePurchase"
               (click)="getBatchTransactions()" [ngClass]="currentComponent=='add'?'unselected-btn':'selected-btn'">
            <button class="transaction-submit-button">
                <span class="icon" style="align-items: center;"><img
                  src="../../../../../../assets/images/New_Icons/view-icon.svg"></span>
              <span class="text">View</span>
            </button>
          </div>
          <div class="transactions-button-container" *ngIf="!currentMultiLinePurchase"
               [ngClass]="currentComponent=='list'?'unselected-btn':'selected-btn'" (click)="onGotoAddBatch()">
            <button class="transaction-submit-button" style="width: 155px">
              <span class="icon"><img src="../../../../../../assets/images/New_Icons/plus-icon.svg"></span>
              <span class="text">Add New</span>
            </button>
          </div>
          <div class="transactions-button-container" *ngIf="currentMultiLinePurchase"
               (click)="getBatchTransactions()" [ngClass]="currentComponent=='add'?'unselected-btn':'selected-btn'">
            <button class="transaction-submit-button" style="padding: 8px 40px">
              <span class="text">Expense</span>
            </button>
          </div>
          <div class="transactions-button-container" *ngIf="currentMultiLinePurchase"
               [ngClass]="currentComponent=='list'?'unselected-btn':'selected-btn'" (click)="onGotoAddBatch()">
            <button class="transaction-submit-button" style="width: 155px; padding: 8px 45px">
              <span class="text">Inventory</span>
            </button>
          </div>
        </div>
      </div>
      <div class="Reports_form_div">
        <form role="form" name="addmapdevice" (clickOutside)="isDropdownOpen = false" class="form-horizontal">
          <div class="reports-form-container">
            <mat-form-field appearance="outline" class="w-100" floatLabel="always" *ngIf="appPermission?.[0].businessSelection">
              <mat-label>Search Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off"
                     placeholder="Search business" (keyup)="filterBusinesses($event)"
                     (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities" [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100" *ngIf="appPermission?.[0].businessNameDisplay">
              <mat-label>Farm Name</mat-label>
              <input matInput [value]="loginUserBusinessName" disabled class="business" style="padding: 0"/>
            </mat-form-field>
            <!--farm site-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Farm Site</mat-label>
              <mat-select id="location"  name="location" [(ngModel)]="farm_site_id" (selectionChange)="getSetionsByFarmsiteId(farm_site_id)">
                <mat-option value="undefined" disabled>Select Farm site</mat-option>
                <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                  {{ (farmsite?.farmNameAtLocation) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!--section-->
            <mat-form-field appearance="outline" class="w-100" *ngIf="!currentMultiLinePurchase">
              <mat-label>Sections</mat-label>
              <mat-select id="section_id" name="section_id" [(ngModel)]="section_id" (selectionChange)="OnSectionSelection()">
                <mat-option value="undefined" disabled>Select Sections</mat-option>
                <mat-option *ngFor="let sections of pondSections" [value]="sections.id">
                  {{ (sections?.section_name) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100" *ngIf="currentMultiLinePurchase">
              <mat-label>Transaction Type</mat-label>
              <input matInput name="transactiontype" placeholder=" " [readonly]="true" [value]="currentComponent === 'add' ? 'Purchase(+)' : currentComponent === 'list' ? 'Issue(-)' : ''"
                [(ngModel)]="transaction_type_id" autocomplete="off"/>
            </mat-form-field>
          </div>
        </form>
        <div class="buttons-div reports_search_div" *ngIf=" currentComponent=='list' && !currentMultiLinePurchase"
             style="justify-content: right">
          <div class="transactions-button-container" (click)="getBatchTransactions()">
            <button class="transaction-submit-button" [disabled]="!business_id||!farm_site_id||!section_id">
              <span class="goicon"><img src="../../../../../../assets/images/New_Icons/go.svg"></span>
              <span class="text">Go</span>
            </button>
          </div>
        </div>
        <div *ngIf="currentFeedLogPage">
          <app-batch-transaction *ngIf=" currentComponent=='add' && section_id"
                                 (gotoBatchList)="refreshList($event)"
                                 [businessId]="business_id"
                                 [businessName]="businessName"
                                 [siteId]="farm_site_id"
                                 [sectionId]="section_id"></app-batch-transaction>
          <app-batch-transactions *ngIf="currentComponent=='list'&&business_id&&farm_site_id&&section_id"
                                  [businessId]="business_id"
                                  [siteId]="farm_site_id"
                                  [sectionId]="section_id"></app-batch-transactions>
        </div>
        <div *ngIf="currentTreatmentPage">
          <app-addtreatment *ngIf=" currentComponent=='add' && section_id"
                            (gotoTreatmentList)="refreshList($event)"
                            [businessId]="business_id"
                            [businessName]="businessName"
                            [siteId]="farm_site_id"
                            [sectionId]="section_id"></app-addtreatment>
          <app-treatments *ngIf="currentComponent=='list'&&business_id&&farm_site_id&&section_id"
                          [businessId]="business_id"
                          [siteId]="farm_site_id"
                          [sectionId]="section_id"></app-treatments>
        </div>
        <div *ngIf="currentWaterQualityPage">
          <app-batch-water-quality *ngIf=" currentComponent=='add' && section_id"
                                   (gotoWaterQualityList)="refreshList($event)"
                                   [businessId]="business_id"
                                   [businessName]="businessName"
                                   [siteId]="farm_site_id"
                                   [sectionId]="section_id"></app-batch-water-quality>
          <app-batch-water-quality-view *ngIf="currentComponent=='list'&&business_id&&farm_site_id&&section_id"
                                        [businessId]="business_id"
                                        [siteId]="farm_site_id"
                                        [sectionId]="section_id"></app-batch-water-quality-view>
        </div>
        <div *ngIf="currentMultiLinePurchase">
          <app-multi-line-purchase *ngIf=" currentComponent=='add' &&business_id&&farm_site_id"
                                   (gotoMultiLine)="refreshList($event)"
                                   [businessId]="business_id"
                                   [businessName]="businessName"
                                   [locationName]="locationName"
                                   [siteId]="farm_site_id"></app-multi-line-purchase>
          <app-multiline-expense *ngIf=" currentComponent=='list'&&business_id&&farm_site_id"
                                 (gotoMultiLine)="refreshList($event)"
                                 [businessId]="business_id"
                                 [businessName]="businessName"
                                 [locationName]="locationName"
                                 [siteId]="farm_site_id"></app-multiline-expense>
        </div>
      </div>
    </div>
  </div>
</div>
